import * as ambassadorWixSeatingV1SeatingReservation from './seating-v1-seating-reservation-seating-reservation.http.js';
import * as ambassadorWixSeatingV1SeatingReservationTypes from './seating-v1-seating-reservation-seating-reservation.types.js';
import * as ambassadorWixSeatingV1SeatingReservationUniversalTypes from './seating-v1-seating-reservation-seating-reservation.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createSeatingReservation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.CreateSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.CreateSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.CreateSeatingReservationResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.CreateSeatingReservationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.createSeatingReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/reservations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSeatingReservation(): __PublicMethodMetaInfo<
  'GET',
  { reservationId: string },
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingReservationResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingReservationResponse
> {
  const payload = { reservationId: ':reservationId' } as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.getSeatingReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/reservations/{reservationId}',
    pathParams: { reservationId: 'reservationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function querySeatingReservations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.QuerySeatingReservationsRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.QuerySeatingReservationsRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.QuerySeatingReservationsResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.QuerySeatingReservationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.querySeatingReservations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/reservations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteSeatingReservation(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.DeleteSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.DeleteSeatingReservationRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.DeleteSeatingReservationResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.DeleteSeatingReservationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.deleteSeatingReservation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/reservations/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSeatingCategorySummaryByExternalId(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingCategorySummaryByExternalIdRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingCategorySummaryByExternalIdRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingCategorySummaryByExternalIdResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingCategorySummaryByExternalIdResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.getSeatingCategorySummaryByExternalId(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/reservations/seating-category-summary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSeatingReservationSummaryByExternalId(): __PublicMethodMetaInfo<
  'GET',
  { externalId: string },
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingReservationSummaryByExternalIdRequest,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingReservationSummaryByExternalIdRequest,
  ambassadorWixSeatingV1SeatingReservationUniversalTypes.GetSeatingReservationSummaryByExternalIdResponse,
  ambassadorWixSeatingV1SeatingReservationTypes.GetSeatingReservationSummaryByExternalIdResponse
> {
  const payload = { externalId: ':externalId' } as any;

  const getRequestOptions =
    ambassadorWixSeatingV1SeatingReservation.getSeatingReservationSummaryByExternalId(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/reservations/seating-reservation-summary/{externalId}',
    pathParams: { externalId: 'externalId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SeatingReservation as SeatingReservationOriginal,
  PlaceReservation as PlaceReservationOriginal,
  SeatingPlanCategoriesSummaryUpdated as SeatingPlanCategoriesSummaryUpdatedOriginal,
  CategoryDetails as CategoryDetailsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateSeatingReservationRequest as CreateSeatingReservationRequestOriginal,
  CreateSeatingReservationResponse as CreateSeatingReservationResponseOriginal,
  Places as PlacesOriginal,
  UnavailablePlaces as UnavailablePlacesOriginal,
  ReservationErrorDetails as ReservationErrorDetailsOriginal,
  GetReservationRequest as GetReservationRequestOriginal,
  GetReservationResponse as GetReservationResponseOriginal,
  GetSeatingReservationRequest as GetSeatingReservationRequestOriginal,
  GetSeatingReservationResponse as GetSeatingReservationResponseOriginal,
  QuerySeatingReservationRequest as QuerySeatingReservationRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QuerySeatingReservationResponse as QuerySeatingReservationResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QuerySeatingReservationsRequest as QuerySeatingReservationsRequestOriginal,
  QuerySeatingReservationsResponse as QuerySeatingReservationsResponseOriginal,
  DeleteSeatingReservationRequest as DeleteSeatingReservationRequestOriginal,
  DeleteSeatingReservationResponse as DeleteSeatingReservationResponseOriginal,
  DeleteSeatingPlaceReservationRequest as DeleteSeatingPlaceReservationRequestOriginal,
  Empty as EmptyOriginal,
  CancelSeatingPlaceReservationsRequest as CancelSeatingPlaceReservationsRequestOriginal,
  PlaceReservationDetails as PlaceReservationDetailsOriginal,
  CancelSeatingPlaceReservationsResponse as CancelSeatingPlaceReservationsResponseOriginal,
  UpdateSeatingReservationRequest as UpdateSeatingReservationRequestOriginal,
  UpdateSeatingReservationResponse as UpdateSeatingReservationResponseOriginal,
  GetReservedPlacesRequest as GetReservedPlacesRequestOriginal,
  GetReservedPlacesResponse as GetReservedPlacesResponseOriginal,
  ListReservedPlacesRequest as ListReservedPlacesRequestOriginal,
  ListReservedPlacesResponse as ListReservedPlacesResponseOriginal,
  SeatReservation as SeatReservationOriginal,
  ReservedPlace as ReservedPlaceOriginal,
  PagingMetadata as PagingMetadataOriginal,
  GetSeatingCategorySummaryRequest as GetSeatingCategorySummaryRequestOriginal,
  GetSeatingCategorySummaryResponse as GetSeatingCategorySummaryResponseOriginal,
  GetSeatingCategorySummaryByExternalIdRequest as GetSeatingCategorySummaryByExternalIdRequestOriginal,
  GetSeatingCategorySummaryByExternalIdResponse as GetSeatingCategorySummaryByExternalIdResponseOriginal,
  GetSeatingReservationSummaryRequest as GetSeatingReservationSummaryRequestOriginal,
  GetSeatingReservationSummaryResponse as GetSeatingReservationSummaryResponseOriginal,
  SeatingPlan as SeatingPlanOriginal,
  Section as SectionOriginal,
  Element as ElementOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Sequencing as SequencingOriginal,
  Place as PlaceOriginal,
  PlaceTypeEnumType as PlaceTypeEnumTypeOriginal,
  PlaceTypeEnumTypeWithLiterals as PlaceTypeEnumTypeWithLiteralsOriginal,
  ReservationOptions as ReservationOptionsOriginal,
  ElementUiProperties as ElementUiPropertiesOriginal,
  ShapeTypeEnumType as ShapeTypeEnumTypeOriginal,
  ShapeTypeEnumTypeWithLiterals as ShapeTypeEnumTypeWithLiteralsOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  Icon as IconOriginal,
  IconWithLiterals as IconWithLiteralsOriginal,
  Image as ImageOriginal,
  Numbering as NumberingOriginal,
  NumberingWithLiterals as NumberingWithLiteralsOriginal,
  MultiRowProperties as MultiRowPropertiesOriginal,
  RowElement as RowElementOriginal,
  RowElementUiProperties as RowElementUiPropertiesOriginal,
  VerticalSequencing as VerticalSequencingOriginal,
  Category as CategoryOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  SeatingPlanUiProperties as SeatingPlanUiPropertiesOriginal,
  ElementGroup as ElementGroupOriginal,
  ElementGroupUiProperties as ElementGroupUiPropertiesOriginal,
  GetSeatingReservationSummaryByExternalIdRequest as GetSeatingReservationSummaryByExternalIdRequestOriginal,
  GetSeatingReservationSummaryByExternalIdResponse as GetSeatingReservationSummaryByExternalIdResponseOriginal,
  RegenerateSummariesRequest as RegenerateSummariesRequestOriginal,
  RegenerateSummariesResponse as RegenerateSummariesResponseOriginal,
  SeatingReservationsSummary as SeatingReservationsSummaryOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  ListAvailablePlacesRequest as ListAvailablePlacesRequestOriginal,
  ListAvailablePlacesResponse as ListAvailablePlacesResponseOriginal,
  AvailablePlace as AvailablePlaceOriginal,
  DeleteSeatingReservationByExternalIdRequest as DeleteSeatingReservationByExternalIdRequestOriginal,
  DeleteSeatingReservationByExternalIdResponse as DeleteSeatingReservationByExternalIdResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateSeatingReservationApplicationErrors as CreateSeatingReservationApplicationErrorsOriginal,
} from './seating-v1-seating-reservation-seating-reservation.types.js';
